// ──────────────────────────────────────────────────────────
// src/hooks/useInfiniteScroll.js
import { useState, useEffect, useRef } from 'react';

export default function useInfiniteScroll(items, pageSize, containerRef) {
  const [visible, setVisible] = useState([]);
  const pageRef = useRef(1);

  // reset when items change
  useEffect(() => {
    pageRef.current = 1;
    setVisible(items.slice(0, pageSize));
  }, [items, pageSize]);

  // attach scroll listener
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const onScroll = () => {
      console.log('🌀 Scroll event on container:', {
        scrollTop: el.scrollTop,
        clientHeight: el.clientHeight,
        scrollHeight: el.scrollHeight
      });
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
        pageRef.current += 1;
        setVisible(items.slice(0, pageRef.current * pageSize));
      }
    };

    el.addEventListener('scroll', onScroll);
    return () => el.removeEventListener('scroll', onScroll);
  }, [items, pageSize, containerRef]);

  return visible;
}
